import React, { Component } from 'react';
import './App.css';
import { Navheader } from './components/Navigation/NavigationBarToggle';
import { Footer } from './components/Footer/Footer';
//import { createHashHistory } from 'history';
import {Switch, Route, Redirect } from "react-router-dom";
import "isomorphic-fetch";
import UserManager from './Core/UserManager';
import Config from './Core/Config.js';
import img1 from './images/back_home_up.png';
import img2 from './images/back_home-down.png';
import img3 from './images/logo.png';
import img4 from './images/iranapps.png';
import img5 from './images/mostaghim.png';
//import img6 from './images/cando.png';
import img7 from './images/sibche.png';
import img8 from './images/mobile.png';
 import img9 from './images/app.jpg';
 import img10 from './images/farhang-main-page1.png';
 import img11 from './images/myket.png';
import imgsibapp from './images/sibapp2.png';
import form from './images/form.png';
// import img14 from '';
import {framework} from 'saffroncodejs';
var PageManager = framework.PageManager ;
var PageData = framework.PageData ;


class App extends Component {

    constructor(param)
    {
        super(param);

    }
    render() {
       
        
        
        return (
            < div>
               <main>
    <div class="back_top"><img src={img1} /></div>
    <div class="back_bottom"><img src={img2} /></div>
    {/* <header>
      <nav>
        <ul class="nav justify-content-center">
          <li class="nav-item">
            <a class="nav-link" href="about.html">درباره ما</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="contactus.html">تماس با ما</a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" href="index.html">صفحه اصلی </a>
          </li>
        </ul>
      </nav>
    </header> */}

    <section>

      <div class="row">
        
        <div class="col-12 col-sm-12 col-md-12">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-6">
              <div class="d-flex flex-column  justify-content-center text-box" style={{paddingTop: "1%", minHeight: "auto"}}>
                <img src={img3} />
                <p>
                کرونا مسئله ای است که این روزها همه ما را درگیر خود کرده است. یکی از مهم ترین مسئله های امروز کشور، آموزش و اطلاع رسانی همگانی برای مقابله و پیشگیری از شیوع این بیماری است. همانطور که در بسیاری از حوزه های دیگر اقتصادی، اجتماعی، فرهنگی و ... شاهد تغییر چهره کسب و کارهای سنتی و ظهور استارتاپ ها و کسب و کارهای دیجیتال مبتنی بر نوآوری بوده ایم. برای حل این معضل نیز می توان از ظرفیت های اقتصاد دیجیتال و اقتصاد دانش بنیان استفاده نمود. </p><p>
حل مسئله کرونا بیشتر از جنبه های بهداشتی نیاز به آموزش، اطلاع رسانی و همدلی همگانی دارد. سیوان ایجاد بستری برای استفاده از پتانسیل های اکوسیستم استارتاپی و کارآفرینی کشور را در حل مسائل کلان کشور رسالت خود می داند و بر مبنای همین رسالت برای موضوع کرونا نیز سعی دارد تا با ایجاد یکی پویش اجتماعی ، تشکیل یک کارگروه و تولید محتوا و تجمیع آموزش ها و نیازهای سازمان های مختلف در  قالب یک اپلیکیشن موبایل و از طریق بر انگیختن همدلی عمومی به رفع این مشکل کمک کند.
</p><p>این پویش با همکاری ستاد فرهنگ سازی علم و اقتصاد دانش بنیان معاونت علمی و فناوری ریاست جمهوری توسط سیوان استیشن راهبری می شود
                </p>
                <ul class="download_links">
                    <li><a href="" target="_blank"><img src={img4} /></a></li>
                    <li><a href="files/coronaapp.apk" download><img src={img5} /></a></li>
                    <li><a href="" target="_blank"><img src={imgsibapp} /></a></li>
                    <li><a href="https://myket.ir/app/air.com.mteamapps.safiransalamat" target="_blank"><img src={img11} /></a></li> 
                    <li><a href="https://sibche.com/applications/%D8%B3%D9%81%D9%8A%D8%B1%D8%A7%D9%86-%D8%B3%D9%84%D8%A7%D9%85%D8%AA%D9%8A" target="_blank"><img src={img7}/></a></li>
                    
                  </ul>
                  <div class="download_links">
                  <li style={{width:'100%'}}>
                  <a href="http://c1station.ir/%d8%a7%d8%b3%d8%aa%d8%a7%d8%b1%d8%aa%d8%a7%d9%be-%d9%87%d8%a7-%d8%b9%d9%84%db%8c%d9%87-%da%a9%d8%b1%d9%88%d9%86%d8%a7/" target="_blank"><img style={{width:'100%'}} src={form}/></a>
                  </li>
                  </div>
                 
                  <br/><br/>
                  <hr/>
                  <div class="row">
                    <div class="col-12 col-sm-12 text-box" style={{padding:'0%', height:'150px', minHeight:'auto'}}>
                     
                      <div style={{display:'flex', textAlign: 'center', direction:'rtl'}}>
                        <img style={{display :'inlineBlock', margin: '0px auto', borderRadius:'5px', height: '150px', width: 'auto', padding: '0px',cursor:'pointer'}} src={img9} onClick={()=>window.open('http://c1station.ir')}  />&nbsp;&nbsp;
                        <img style={{display :'inlineBlock', margin: '0px auto', borderRadius:'5px', height: '150px', width: 'auto', padding: '0px',cursor:'pointer' }} src={img10} onClick={()=>window.open('http://farhang.isti.ir/')}  />
                        
                      </div>
                    </div>
                  </div>
                  
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 d-none d-sm-block d-md-block d-lg-block" >
              <div class="d-flex flex-column  align-content-end flex-wrap mobile-holder">
                <img src={img8} />
              </div>
            </div>
          </div>
        </div>

      </div>

    </section>

    <footer>

    </footer>

  </main>      


            </div>
        )
    
}
    }

export default App;


// WEBPACK FOOTER //
// ./src/App.js